import React from "react";

/**
 * Newsletter block for the footer column (stationary — not viewport-sticky).
 * Styling aligns with design/design-system.json.
 */
export default function NewsletterBand() {
  return (
    <aside id="site-newsletter" className="mt-8 w-full scroll-mt-24 border-t border-border pt-6">
      <div className="w-full rounded-ds-xl border border-border bg-canvas-subtle p-4 shadow-card" data-tour="footer-newsletter" aria-label="Newsletter signup">
        <p className="text-sm text-fg-secondary">Newsletter signup will be delivered in a future update.</p>
      </div>
    </aside>
  );
}
